import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import exportTable from "../../../lib/exportTable";
import { IEnrolledStudentClass } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import DownloadButton from "../../DownloadButton";
import moment from "moment";
import useUtil from "../../../hooks/useUtil";

interface IProps {
  res: any;
}

const Classes: FC<IProps> = ({
  res,
}) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { getCommonCodeLabel } = useUtil();

  const [data, setData] = useState<IEnrolledStudentClass[]>([]);

  useEffect(() => {
    if (res.length) {
      // @ts-ignore
      const _data: any = [];
      res.at(0)?.data?.forEach((campus: IEnrolledStudentClass) => {
        campus.courseInfo?.forEach((course: any) => {
          course.classInfo?.forEach((item: any) => {
            _data.push({
              ...item,
              campusCode: campus.campusCode,
              campusEngName: campus.campusEngName,
              campusKorName: campus.campusKorName,
              courseName: course.courseName,
            });
          });
        });
      });

      if (auth.hqYn === 'Y') {
        const total: any = {
          campusCode: 'total',
          campusEngName: 'Total',
          campusKorName: t('student.student.column47'),
          eduStepCode: '',
          courseName: '',
          className: '',
          reCount: _data.reduce((acc: number, cur: any) => acc + cur.reCount, 0),
          plCount: _data.reduce((acc: number, cur: any) => acc + cur.plCount, 0),
          s1Count: _data.reduce((acc: number, cur: any) => acc + cur.s1Count, 0),
          s2Count: _data.reduce((acc: number, cur: any) => acc + cur.s2Count, 0),
        }
        total.reRegisterRate = Math.round(total.s2Count / total.reCount * 100) || null;
        _data.push(total);
      }

      setData(_data);      
    }
  }, [res]);

  const onExportTable = () => {
    const _data: any = _.cloneDeep(data);
    _data.forEach((item: any) => {
      item.reRegisterRate = item.reRegisterRate ? `${item.reRegisterRate}%` : '-';
    });
    const currentDate = moment(new Date());
    exportTable(columns, _data, `${t('statistics.regularTest.7')}_(${currentDate.format('YYYYMMDD')})`, t('common.menu.class'), [12, 12, 20, 10, 10, 10, 10, 12]);
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      align: 'center',
    },
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value),
    },
    {
      title: t('student.student.column27'),
      dataIndex: 'courseName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      align: 'center',
    },
    {
      title: t('statistics.studentEnrollMonth.column1'),
      dataIndex: 'reCount',
      align: 'center',
    },
    {
      title: t('statistics.studentEnroll.column3'),
      dataIndex: 'plCount',
      align: 'center',
    },
    {
      title: t('statistics.studentEnrollMonth.column2'),
      dataIndex: 's1Count',
      align: 'center',
    },
    {
      title: t('statistics.studentEnrollMonth.column3'),
      dataIndex: 's2Count',
      align: 'center',
    },
    {
      title: t('statistics.studentEnroll.column4'),
      dataIndex: 'reRegisterRate',
      align: 'center',
      render: value => value ? `${Math.round(value)}%` : '-',
    },
  ];

  return (
    <>
      <div className="comm-table__area">
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          current: 1,
          pageSize: 999999999,
        }}
        rowClassName={(record: IEnrolledStudentClass) => record.campusCode === 'total' ? 'tfoot' : ''}
      />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
      </div>    
    
    </>
  );
}

export default Classes;
